import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_PL.json';
import exercises from './FITNESS_EXERCISES_PL.json';
import recipes from './FITNESS_RECIPES_PL.json';

export const FITNESS_DATA_PL: ServiceData = {
  articles,
  exercises,
  recipes,
};
